export default {
  name: 'misc.occupation',
  key: 'occupation',
  attributes: {
    hermit: {
      key: 'hermit',
      name: 'entity.refuelingStation.occupation.hermit',
    },
    fun: {
      key: 'fun',
      name: 'entity.refuelingStation.occupation.fun',
    },
    minions: {
      key: 'minions',
      name: 'entity.refuelingStation.occupation.minions',
    },
    religious: {
      key: 'religious',
      name: 'entity.refuelingStation.occupation.religious',
    },
    vendors: {
      key: 'vendors',
      name: 'entity.refuelingStation.occupation.vendors',
    },
  },
};
